import React from "react";
import BasicModal from "@components/modal/BasicModal";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { Flex } from "antd";

const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1.6rem",
  width: "100%",
  fontSize: "1.2rem",
  lineHeight: "2rem",

  ".title": {
    fontSize: "1.6rem",
    fontWeight: theme.fontWeight.bold,
    lineHeight: "1.6rem",
    marginBottom: "2rem",
    alignSelf: "center",
  },

  ".sub_title": {
    color: theme.color.green,
    fontWeight: theme.fontWeight.bold,
    fontSize: "1.4rem",
    lineHeight: "1.6rem",
    marginBottom: "2rem",
  },

  ".warning": {
    color: theme.color.gray,
    marginBottom: "2rem",
  },
}));

type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
const ExchangeRefundModal = ({ open, setOpen }: Props) => {
  const handleOpenTerms = () => {
    window.open(
      "https://owlsociety.notion.site/Exchange-Return-Refund-Items-af558def00fd4ad5a98ef6c0873d6bc6",
      "_blank",
    );
  };

  const { t } = useTranslation();
  const lang = window.localStorage.getItem("language");

  return (
    <BasicModal
      open={open}
      setOpen={setOpen}
      activeName="자세히"
      activeEvent={handleOpenTerms}
      closeName="닫기">
      <Container>
        <span className="title">{t("꼭 읽어주세요!")}</span>

        <span className="sub_title">{t("교환 환불 안내")}</span>

        <p>
          {t(
            "• 샤카라카는 세일상품, 세컨핸드 등 리세일 패션 전문 마켓플레이스로,\n" +
              "          개인 판매자로부터 구매한 상품 또는 사업자의 상품이라도 교환/반품\n" +
              "          불가로 표시된 상품은 교환/환불이 불가해요.",
          )}
        </p>

        <p>
          {t(
            "만약 구매한 상품이 마음에 들지 않는다면, 재판매에 대한 수수료 없이\n" +
              "          다시 판매 등록할 수 있어요.",
          )}
        </p>

        <p className="warning">
          {t(
            "(단, 재판매시 세금 및 신용카드 수수료 (3.3%)는 거래금액 정산 시 공제됩니다.",
          )}
        </p>

        <p>
          {t("• 반드시 교환/반품을 해야겠다면 판매자에게 댓글로 문의해보세요.")}
        </p>

        <p>
          {lang === "ko" &&
            `판매자 동의 시 > 구매자 반품 발송(각자) > 판매자 수거 후, 상품
          확인 후 고객센터로 판매 취소를 요청해주세요.`}

          <Flex vertical gap="2.4rem">
            <p>
              {lang === "en" &&
                `Return Process (with Seller's Agreement):
          `}
            </p>

            <Flex vertical>
              <p>
                {lang === "en" &&
                  `
          a. Buyer ships the return. (Shipping costs may be the buyer's responsibility, so please confirm with the seller in advance.) 
          `}
              </p>

              <p>
                {lang === "en" &&
                  `
          b. Seller receives and inspects the item. 
          `}
              </p>

              <p>
                {lang === "en" &&
                  `c. Seller requests order cancellation through customer support.
          `}
              </p>
            </Flex>
          </Flex>
        </p>
      </Container>
    </BasicModal>
  );
};

export default ExchangeRefundModal;
